import { createChat } from './main';
import { getIsChatIdle } from './selectors/chat';
import { isUserLoggedFromMaco } from './selectors/chat-session';
import configureStore from './store';
import { on, trigger } from './app-communication/events-manager';
import { initWebsocket } from './app-communication/actions/from-client-frontend';
import EVENTS from './app-communication/constants/events';
import { validateMissingParam } from './app-communication/utils/params-validation';
import { debugEvent } from './actions/debug';
import { getJwtBodyPart } from './app-communication/utils/jwt';

export const store = configureStore({});

console.log(`Running Chat version - ${process.env.APP_VERSION}`);

const exportedInterface = {
  EVENTS,
  onEvent: on,
  triggerEvent: trigger,
  initWebsocketApi: ({ IMPULSE_URLS = [], CHAT_API = null, clientToken, username, firstName, lastName, language }) => {
    validateMissingParam('CHAT_API', CHAT_API);
    validateMissingParam('IMPULSE_URLS', IMPULSE_URLS);
    validateMissingParam('clientToken', clientToken);
    validateMissingParam('username', username);
    validateMissingParam('firstName', firstName);
    validateMissingParam('lastName', lastName);
    validateMissingParam('language', language);

    store.dispatch(
      debugEvent({
        name: 'INITIALIZED_WS_API',
        payload: {
          clientToken: getJwtBodyPart({ token: clientToken })
        }
      })
    );

    store.dispatch(
      initWebsocket({
        IMPULSE_URLS,
        CHAT_API,
        clientToken,
        username,
        firstName,
        lastName,
        language
      })
    );
  },
  chat: {
    create: createChat,
    canStartNewChat: () => getIsChatIdle(store.getState()) && !isUserLoggedFromMaco(store.getState()),
    store: store.getState(),
    executeIfChatIsNotOpen: (fn) => {
      if (!exportedInterface.chat.canStartNewChat()) {
        exportedInterface.triggerEvent(exportedInterface.EVENTS.INDICATE_CHAT_IS_ACTIVE);
        return;
      }

      fn();
    }
  }
};

export default exportedInterface; // used for UMD export in webpack
